import { getIndexedLocationFilters, getMarket, getMarketFromCityState } from '@atc/bonnet-reference';
import normalizeSeoValue from './normalizeSeoValue';
async function getZipCodeFromCityState(_ref) {
  let {
    city,
    state
  } = _ref;
  // use getIndexedLocationFilters to retrieve the zip code
  const indexedLocation = await getIndexedLocationFilters({
    city,
    state
  });
  if (indexedLocation.success) {
    return indexedLocation.payload.centerZip;
  }

  // If no zipcode is found, use bonnet getMarket to retrieve a zip code
  const gmRes = await getMarketFromCityState({
    city,
    state
  });
  if (gmRes.success) {
    return gmRes.payload.zip;
  }
  return '';
}
export default async function decodeLocation(_ref2) {
  let {
    parsedValue,
    queryZip
  } = _ref2;
  // City names can have periods or single ticks
  const pattern = new RegExp(/^([A-Za-z\s.']+)(?:\s)+([A-Za-z]{2})(?=\s)(?=.\d)(?:\s)+(\d{5})$/); // city state zip
  const nozipPattern = new RegExp(/^([A-Za-z\s.']+)(?:\s)+([A-Za-z]{2}$)/); // city state

  const match = parsedValue.match(pattern) || parsedValue.match(nozipPattern);
  if (match) {
    // eslint-disable-next-line no-unused-vars
    const [input, city, state, zip] = match;
    if (zip) {
      return {
        city: normalizeSeoValue(city),
        state,
        zip
      };
    }
    if (queryZip) {
      // use the zip code if it's provided in the query
      const {
        success,
        payload: location
      } = await getMarket(queryZip);
      if (success) {
        return {
          city: normalizeSeoValue(location.city),
          state: location.state,
          zip: queryZip
        };
      }
    }
    const rvrsZip = await getZipCodeFromCityState({
      city,
      state
    });
    if (rvrsZip) {
      return {
        city: normalizeSeoValue(city),
        state,
        zip: rvrsZip
      };
    }
  }
  return {};
}